export default "__VITE_ASSET__Bj2w7ZqI__"